export function getFileExtension(fileName = "", defaultExt = "png") {
  if (!fileName) return defaultExt;
  let result = "";
  if (isBase64File(fileName)) {
    const mimeType = getMimeTypeBase64(fileName);
    result = mimeType.split("/").pop();
  } else {
    result = fileName.split("?")[0].split(".").pop();
  }
  return result;
}

export function isFileTypePDF(fileName) {
  return isBase64File(fileName)
    ? getMimeTypeBase64(fileName).includes("pdf")
    : getFileExtension(fileName).toLowerCase() === "pdf";
}

export function downloadFileFromURL(linkURL, filename = "image.png", mimeType) {
  return new Promise((res, rej) => {
    fetch(linkURL)
      .then((response) => response.arrayBuffer())
      .then((buffer) => {
        const blob = new Blob([buffer], { type: mimeType ? mimeType : "image/png" });

        //Check the Browser type and download the File.
        const isIE = false || !!document.documentMode;
        if (isIE) {
          window.navigator.msSaveBlob(blob, filename);
        } else {
          const link = document.createElement("a");
          document.body.appendChild(link);
          const url = window.URL.createObjectURL(blob);
          link.href = url;
          link.setAttribute("download", filename);
          link.click();
          document.body.removeChild(link);
          res();
        }
      })
      .catch((err) => rej(err));
  });
}

export async function downloadImageFromLink(linkURL, filename = "image.png") {
  try {
    const response = await fetch(linkURL);
    const buffer = await response.arrayBuffer();
    const url = window.URL.createObjectURL(new Blob([buffer]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch {}
}

export async function directDownloadFromLink(linkURL, filename = "image.png") {
  try {
    const link = document.createElement("a");
    link.href = linkURL;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch {}
}

export function isBase64File(file = "") {
  if (!file) return;
  const base64Pattern = /^data:[a-z]+\/[a-z0-9\-.+]+;base64,/i;
  return base64Pattern.test(file);
}

export function getMimeTypeBase64(base64String) {
  const mimePattern = /^data:([a-z]+\/[a-z0-9\-.+]+);base64,/i;
  const match = base64String.match(mimePattern);

  return match ? match[1] : null;
}
